import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import SearchSaveNotification, {SEARCH_SAVE_NOTIFICATION_TYPES} from './search-save-notification.js'
import {formatNotAvailableFiltersText} from './utils.js'

const SearchSaveSuccessNotification = ({alert, show, onClose = () => {}, portalContainer, className}) => {
  const {i18n} = useContext(Context)

  const text = formatNotAvailableFiltersText({
    filters: alert?.notAvailableFilters,
    i18n
  })

  const getNotificationMessage = notAvailableFilter => {
    if (notAvailableFilter !== '') {
      return i18n.t('SEARCH_SAVE_NOTIFICATION_SUCCESS_FOR_NOT_AVAILABLE_FILTERS', {
        smart_count: alert?.notAvailableFilters.length || 0,
        notAvailableFilter
      })
    }
    return i18n.t('SEARCH_SAVE_NOTIFICATION_SUCCESS')
  }

  return (
    <SearchSaveNotification
      className={className}
      onClose={onClose}
      portalContainer={portalContainer}
      show={show}
      type={SEARCH_SAVE_NOTIFICATION_TYPES.SUCCESS}
    >
      {getNotificationMessage(text)}
    </SearchSaveNotification>
  )
}

SearchSaveSuccessNotification.propTypes = {
  alert: PropTypes.object,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  portalContainer: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.object,
  className: PropTypes.string
}

export default SearchSaveSuccessNotification
